const ORDER_DATE_PATTERN = /^(\d{2})\.(\d{2})\.(\d{4})$/;

/**
 * Преобразует дату заказа из отображаемого API-формата DD.MM.YYYY
 * в сопоставимое число YYYYMMDD. Некорректные даты возвращают null.
 *
 * @param {unknown} value
 * @returns {number|null}
 */
export function parseOrderDate(value) {
    if (typeof value !== 'string') {
        return null;
    }

    const match = value.trim().match(ORDER_DATE_PATTERN);
    if (!match) {
        return null;
    }

    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);

    if (year < 1 || month < 1 || month > 12) {
        return null;
    }

    const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (day < 1 || day > daysInMonth[month - 1]) {
        return null;
    }

    return year * 10000 + month * 100 + day;
}

/**
 * Получает значение для сортировки из объекта
 * @param {Object} item - объект данных
 * @param {string} key - ключ поля
 * @returns {any} - значение для сортировки
 */
export function getSortValue(item, key) {
    const value = item?.[key];

    // API списка заказов возвращает поле date в формате DD.MM.YYYY.
    if (key === 'date') {
        return parseOrderDate(value);
    }

    // Для денежных полей
    if (key === 'summa' || key === 'summa_work') {
        return value === null || value === undefined || value === ''
            ? null
            : Number(String(value).replace(/\s+/g, '').replace(',', '.'));
    }

    // Для числовых полей
    if (key === 'number') {
        return value ?? null;
    }

    return value ?? null;
}

/**
 * Сортирует массив данных
 * @param {Array} data - массив для сортировки
 * @param {string} sortKey - ключ сортировки
 * @param {string} sortDir - направление ('asc' или 'desc')
 * @param {Function|null} customGetter - функция для получения значения (item, key) => value
 * @returns {Array} - отсортированный массив
 */
export function sortArray(data, sortKey, sortDir = 'asc', customGetter = null) {
    const items = [...(data || [])];

    return items.sort((a, b) => {
        const aValue = customGetter ? customGetter(a, sortKey) : getSortValue(a, sortKey);
        const bValue = customGetter ? customGetter(b, sortKey) : getSortValue(b, sortKey);

        if (aValue === bValue) return 0;
        if (aValue == null) return 1;
        if (bValue == null) return -1;

        if (typeof aValue === 'number' && Number.isFinite(aValue) && typeof bValue === 'number' && Number.isFinite(bValue)) {
            return sortDir === 'asc' ? aValue - bValue : bValue - aValue;
        }

        return sortDir === 'asc'
            ? String(aValue).localeCompare(String(bValue), 'ru', { numeric: true, sensitivity: 'base' })
            : String(bValue).localeCompare(String(aValue), 'ru', { numeric: true, sensitivity: 'base' });
    });
}
